import { render, staticRenderFns } from "./_base-package-form.vue?vue&type=template&id=3f5c7f15"
import script from "./_base-package-form.vue?vue&type=script&lang=js"
export * from "./_base-package-form.vue?vue&type=script&lang=js"
import style0 from "./_base-package-form.vue?vue&type=style&index=0&id=3f5c7f15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports